import { useCampaignApplyingRange } from "@/hooks";
import formatPrice from "@/lib/formatPrice";
import styles from "@/styles/Payment.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ApplyingCampaignStatusModal(_ref) {
  let {
    subscription
  } = _ref;
  const {
    course,
    status,
    initialTransactionAt,
    trialStartAt,
    trialEndAt
  } = subscription;
  const {
    active_pricing: price
  } = course;

  // トライアルがある場合は、キャンペーンの開始日時を再計算する
  const [campaignStartAt, campaignEndAt] = useCampaignApplyingRange(price === null || price === void 0 ? void 0 : price.campaign, initialTransactionAt, status === "trial", trialEndAt);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: `${styles.container} ${styles.compact}`,
      children: /*#__PURE__*/_jsx("div", {
        className: `${styles.section} ${styles.column}`,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.table,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.label,
              children: "\u901A\u5E38\u4FA1\u683C"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.value,
              children: /*#__PURE__*/_jsxs("span", {
                className: styles.priceAmount,
                children: [/*#__PURE__*/_jsx("span", {
                  children: "\u6708\u984D"
                }), " ", formatPrice(course.defaultPrice), "\u5186", /*#__PURE__*/_jsx("span", {
                  children: "\uFF08\u7A0E\u8FBC\uFF09"
                })]
              })
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.containerHeader,
        children: /*#__PURE__*/_jsx("div", {
          children: "\u304A\u5BA2\u69D8\u306B\u9069\u7528\u4E2D\u307E\u305F\u306F\u9069\u7528\u4E88\u5B9A\u306E\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3"
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: `${styles.container} ${styles.box} ${styles.compact}`,
      children: [status === "trial" && /*#__PURE__*/_jsxs("div", {
        className: `${styles.section} ${styles.column}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.header,
          children: course.trialText
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.table,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.label,
              children: "\u9069\u7528\u671F\u9593"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.value,
              children: [trialStartAt, " \u301C ", trialEndAt]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.label,
              children: "\u91D1\u984D"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.value,
              children: ["\u7121\u6599\uFF08", course.trialCampaignFlag ? course.trialText : "トライアル", "\uFF09"]
            })]
          })]
        })]
      }), (price === null || price === void 0 ? void 0 : price.campaign) && /*#__PURE__*/_jsxs("div", {
        className: `${styles.section} ${styles.column}`,
        children: [status === "trial" && /*#__PURE__*/_jsxs("div", {
          children: [course.trialCampaignFlag ? "キャンペーン" : "トライアル", "\u671F\u9593\u7D42\u4E86\u5F8C"]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.header,
          children: price === null || price === void 0 ? void 0 : price.campaign.name
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.table,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.label,
              children: "\u9069\u7528\u671F\u9593"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.value,
              children: [campaignStartAt, " \u301C ", campaignEndAt]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.label,
              children: "\u91D1\u984D"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.value,
              children: /*#__PURE__*/_jsxs("span", {
                className: styles.priceAmount,
                children: [/*#__PURE__*/_jsx("span", {
                  children: "\u6708\u984D"
                }), " ", formatPrice(price.payment_amount), "\u5186", /*#__PURE__*/_jsx("span", {
                  children: "\uFF08\u7A0E\u8FBC\uFF09"
                })]
              })
            })]
          })]
        })]
      })]
    })]
  });
}